import {DateTime} from 'luxon'

import {Jurisdiction} from '../countries/constants'
import {Price} from '../pricing'

export type OrderedItems = {
  price: Price
}

export enum ServiceTypeB2B {
  registrationB2B = 'registrationB2B',
  filing = 'filing',
  drafting = 'drafting',
}

export enum ServiceTypeB2C {
  registrationB2C = 'registrationB2C',
}

export type ServiceType = ServiceTypeB2B | ServiceTypeB2C
export const ServiceType = {...ServiceTypeB2C, ...ServiceTypeB2B}

export type IpOfficePriceIncreaseAlertContentType = {
  ipOffice: string
  date: DateTime
  linkHref: string
  isVisibleToClient: boolean
}

export type IpOfficePriceIncreaseAlertType = IpOfficePriceIncreaseAlertContentType & {
  jurisdiction: Jurisdiction
}
